<app-title-bar rootBreadCrumbs="['i18n.core.navigation.export-configuration']" titleText="i18n.core.navigation.configurations"></app-title-bar>
<div class="row grow w-100">
  <div class="col-4">
    <div class="row">
      <div class="col-12">
        <app-client-autocomplete [(selectedClient)]="selectedClient" [showHasExportConfigurationFilter]="true"></app-client-autocomplete>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <span class="mt-2 cursor-pointer d-inline-block" (click)="showFilter = !showFilter">
          <span [ngClass]="{'icon-caret--right': !showFilter, 'icon-caret--down': showFilter}"></span>
          {{showFilter ? ('i18n.domain.export-configuration.configurations.overview.filter.hide-filter' | translate) :
          ('i18n.domain.export-configuration.configurations.overview.filter.show-filter' | translate)}}
        </span>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        @if (showFilter) {
          <form [formGroup]="filterForm">
            <div class="row mt-2">
              <div class="col">
                <app-search-field (searchTextChanged)="onSearchTextChanged($event)"></app-search-field>
              </div>
              <div class="col">
                <app-enum-drop-down-list [showClearButton]="true" [enumType]="TransferType" formControlName="transferType"
                  [placeholder]="'i18n.domain.export-configuration.configurations.overview.filter.search-transfer-type'"
                  baseTranslationString='i18n.shared.transferTypes.'>
                </app-enum-drop-down-list>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col">
                <app-multi-select-filter
                  [placeholder]="'i18n.domain.export-configuration.configurations.overview.filter.search-country'"
                  [getDataFunction]="getCountries.bind(this)" [type]="multiSelectItemFilter" [(values)]="selectedCountries">
                </app-multi-select-filter>
              </div>
              <div class="col">
                <app-multi-select-filter
                  [placeholder]="'i18n.domain.export-configuration.configurations.overview.filter.search-sales-person'"
                  [getDataFunction]="getSalesPersonCodes.bind(this)" [(values)]="selectedSalesPersonCodes">
                </app-multi-select-filter>
              </div>
            </div>
          </form>
        }
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-12 d-flex justify-content-between">
        <span>
          {{'i18n.domain.export-configuration.configurations.overview.header' | translate }}
        </span>
        <div class="d-flex align-items-center">
          <span class="e-icons icon-download cursor-pointer"
            title="{{ 'i18n.domain.export-configuration.configurations.overview.export-button-tooltip' | translate }}"
            (click)="exportConfigurationsAsCSV()">
          </span>
          @if (selectedClient &&  authService.isUserAdminOrConfigurationAdmin()) {
            <span class="e-icons icon-add e-icon-big ms-2"
                  title="{{ 'i18n.domain.export-configuration.configurations.overview.add-button-tooltip' | translate }}"
                  (click)="addConfiguration()">
            </span>
          }
        </div>
      </div>
    </div>
    <div class="row">
      <app-configuration-overview (rowSelected)="exportInterfaceConfigurationSelected($event)" [selectedConfigId]="selectedConfigId">
      </app-configuration-overview>
    </div>
  </div>
  <div class="col-8 h-100" [hidden]="!configuration">
    <div class="e-card">
      <div class="e-card-content">
        <app-configuration-forms-overview></app-configuration-forms-overview>
      </div>
      <div class="e-card-actions">
        <div class="d-flex">
          <div class="btn-group me-auto">
            <ejs-tooltip (beforeOpen)="checkShowDeleteTooltip($event)"
              [content]="'i18n.domain.export-configuration.configurations.buttons.delete-tooltip'| translate">
              @if (configuration && authService.isUserAdminOrConfigurationAdmin() ) {
                <button type="button"
                        (click)="deleteConfiguration()"
                        class="btn btn-outline-danger me-2 btn-fixedw rounded"
                        [disabled]="configuration.active">
                  <span class="e-icons icon-erase danger me-2"></span>
                  {{ 'i18n.domain.export-configuration.configurations.buttons.delete' | translate }}
                </button>
              }
            </ejs-tooltip>
            @if (authService.isUserAdminOrConfigurationAdmin()) {
              <button type="button" (click)="loadFromTemplate()" class="btn btn-outline-secondary me-2 btn-fixedw rounded">
                <span class="e-icons icon-cloud--download me-2"></span>
                {{ 'i18n.domain.export-configuration.shared.buttons.load-from-template' | translate }}
              </button>
            }
          </div>
          <div class="btn-group ms-auto">
            <button type="reset" (click)="closeForm()" class="btn btn-outline-secondary me-2 btn-fixedw rounded">
              {{ 'i18n.domain.export-configuration.shared.buttons.discard' | translate }}
            </button>
            @if (authService.canUserEditExportConfigurations() && isExecutionPossible()) {
              <button type="submit" (click)="onSaveAndExecute()" class="btn btn-outline-primary me-2 btn-fixedw rounded">
                {{ 'i18n.domain.export-configuration.shared.buttons.save-and-execute' | translate }}
              </button>
            }
            @if (authService.canUserEditExportConfigurations()) {
              <button type="submit" (click)="onSave()" class="btn btn-outline-primary btn-fixedw rounded">
                {{ 'i18n.domain.export-configuration.shared.buttons.save' | translate }}
              </button>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ejs-dialog #loadTemplateDialog [isModal]="true" [showCloseIcon]="true" [visible]="false" (close)="cancelClicked()"
  (open)="onOpen($event)">
  <ng-template #header>
    {{'i18n.domain.export-configuration.configurations.forms.email.template-selector-title' | translate}}
  </ng-template>

  <ng-template #content>
    <app-configuration-templates-overview #configTemplateOverview (rowDoubleClick)="templateSelectedAndClose($event)"
      (rowSelected)="templateSelected($event)" [configurationType]="configuration?.type" [mode]="configuration?.mode">
    </app-configuration-templates-overview>
  </ng-template>

  <ng-template #footerTemplate>
    <ng-container>
      <button class="e-control e-btn e-lib e-primary e-flat"
              (click)="okClicked()"
              [disabled]="!selectedTemplate">
        {{'i18n.shared.ok' | translate}}
      </button>
      <button class="e-control e-btn e-lib e-flat" (click)="cancelClicked()">{{'i18n.shared.cancel' | translate}}</button>
    </ng-container>
  </ng-template>
</ejs-dialog>
